import React, { PureComponent } from 'react';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import {
  ContentWrapper,
  FooterImage,
  RowWrapper,
  ShopItem,
  ShopImage,
  LinkList,
  Column1,
  Column2,
  Column3,
  Column4,
  Row,
  SHOP_IMAGE_SIZES,
  FooterShop,
  FooterShopWrapper,
  SubscribeFormWrapper,
} from './content.styles';
import { renderWhenNotNil } from '../../../utils/rendering';
import { ContentManager } from '../../../components/contentManager';
import { getField } from '../../../utils/cmsData';
import { ContactUs } from '../../../components/contactUs/contactUs.component';
import { CollapsableLinkList } from '../../../components/collapsableLinkList/collapsableLinkList.component';
import { SectionViewportContext } from '../../../components/contentManager/pageSection/pageSection.component';
import { PlatformDetector } from '../../../components/platformDetector/platformDetector.component';
import { GoogleSearch } from '../../../components/googleSearch';
import { Badges } from '../../../components/badgesWithLink/badges.component';
import {
  FooterBadgeContainer as BadgeContainer,
  FooterBadgeImageContainer as BadgeImageContainer,
} from '../../../components/badgesWithLink/badges.styles';

export class Content extends PureComponent {
  static propTypes = {
    footerImage: PropTypes.string,
    footerImageAlt: PropTypes.string,
    shopItem: PropTypes.object,
    color: PropTypes.string,
    form: PropTypes.object,
    contactUs: PropTypes.object,
    column2: PropTypes.object,
    column3: PropTypes.object,
    shop: PropTypes.object,
    image: PropTypes.object,
    footerBadges: PropTypes.object,
  };

  static defaultProps = {
    column2: List(),
    column3: List(),
  };

  static contextType = SectionViewportContext;

  renderShopItem = renderWhenNotNil(() => {
    const { imageLink, image } = this.props.shop;

    return (
      <ShopItem
        url={getField(['url', 'fields', 'url'], imageLink)}
        ariaLabel={getField(['label'], imageLink)}
      >
        <ShopImage
          src={getField(['file', 'url'], image)}
          alt={getField(['description'], image) || getField(['title'], image)}
          sizes={SHOP_IMAGE_SIZES}
        />
      </ShopItem>
    );
  });

  renderList = (list, index) => (
    <LinkList
      title={getField('title', list)}
      links={getField('items', list)}
      key={`list_${index}`}
    />
  );

  renderCollapsableList = (list, index) => (
    <CollapsableLinkList
      title={getField('title', list)}
      links={getField('items', list)}
      key={`list_${index}`}
    />
  );

  render() {
    const { image, color, column2, column3, shop, form, footerBadges } = this.props;

    return (
      <PlatformDetector>
        {({ isMobile, isTabletPortrait }) => (
          <ContentWrapper color={color}>
            <FooterImage
              src={this.context.isActive ? getField(['file', 'url'], image) : undefined}
              alt={getField(['file', 'fileName'], image)}
            />
            <RowWrapper>
              <Row row>
                <Column1 as="section">
                  <SubscribeFormWrapper>
                    <ContentManager content={form} />
                  </SubscribeFormWrapper>
                  {!isTabletPortrait && <ContactUs {...this.props.contactUs} />}
                </Column1>
                <Column2 as="section">
                  {((isMobile || isTabletPortrait) &&
                    column2.toArray().map(this.renderCollapsableList)) ||
                    column2.toArray().map(this.renderList)}
                </Column2>
                <Column3 as="section">
                  {((isMobile || isTabletPortrait) &&
                    column3.toArray().map(this.renderCollapsableList)) ||
                    column3.toArray().map(this.renderList)}
                  {isTabletPortrait && <GoogleSearch />}
                </Column3>
                <Column4 as="section">
                  {!isTabletPortrait && <GoogleSearch />}
                  {isTabletPortrait && <ContactUs {...this.props.contactUs} />}
                  <FooterShopWrapper>
                    {this.renderShopItem(!!shop)}
                    <FooterShop
                      content={shop.text}
                      link={getField('url', shop.link)}
                      linkLabel={getField('label', shop.link)}
                    />
                  </FooterShopWrapper>
                  <BadgeContainer>
                    <Badges items={footerBadges} ImageWrapper={BadgeImageContainer} />
                  </BadgeContainer>
                </Column4>
              </Row>
            </RowWrapper>
          </ContentWrapper>
        )}
      </PlatformDetector>
    );
  }
}
